// Recovered compiled webpack factory 54058. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  function n(e, t, r) {
    let n,
      a,
      o,
      i = r?.maxWait ? Math.max(r.maxWait, t) : 0,
      s = r?.setTimeoutImpl || setTimeout;
    function l() {
      return (u(), (n = e()));
    }
    function u() {
      (void 0 !== a && clearTimeout(a), void 0 !== o && clearTimeout(o), (a = o = void 0));
    }
    function c() {
      return (a && clearTimeout(a), (a = s(l, t)), i && void 0 === o && (o = s(l, i)), n);
    }
    return (
      (c.cancel = u),
      (c.flush = function () {
        return void 0 !== a || void 0 !== o ? l() : n;
      }),
      c
    );
  }
  r.d(t, { s: () => n });
}
